<ng-container>
  <div class="d-flex align-items-center flex-column">
    <div class="d-flex align-items-center flex-column">
      <credit-box></credit-box>

      <div class="description">
        Veuillez renseigner les informations sur votre credit.
      </div>
    </div>
    <div class="btn-group">
      @if (step > 1) {
        <pr-button
          size="lg"
          type="button"
          label="Question précédente"
          icon="arrow_left"
          (onClick)="prev()"
        ></pr-button>
      }
      <pr-button
        style="margin-left: auto"
        size="lg"
        type="submit"
        display="neutral"
        label="C'est parti !"
        (onClick)="next()"
      ></pr-button>
    </div>
  </div>
</ng-container>
<ng-template #loadingTem>
  @if (loading) {
    <pr-loader></pr-loader>
  }
</ng-template>
